"use client";

import type { UseHiringOfficeSearchParams } from "./types";

import { useQuery } from "@tanstack/react-query";
import { fetchHiringOfficeSearch } from "./fetch-hiring-office-search";

/**
 * React-query fetch wrapper for hiring office geo search.
 */
function useHiringOfficeSearch({
  config,
  ...params
}: UseHiringOfficeSearchParams) {
  return useQuery({
    // Disable query if location is empty or enabled is explicitly false
    enabled: params.enabled !== false && Boolean(params.location?.trim()),
    queryFn: () => fetchHiringOfficeSearch(params, config),
    queryKey: ["hiringOfficeSearch", params, config?.apiEndpoint],
  });
}

export { useHiringOfficeSearch };
